module.exports = __webpack_public_path__ + "static/media/bb_italia.a6cd3962.svg";